import { TYPES } from "./bailiff_dialog.type";

const initState = {
  bailiffDialogUrlAudio: null,
  bailiffDialogPlay: false,
  bailiffDialogSecond: 0,
  bailiffDialogSlot: 0,
  bailiffDialogKick: null,
  //
  bailiffDialogOptionSpeaker: [],
};

const bailiffDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_BAILIFF_DIALOG_URL_AUDIO:
      return {
        ...state,
        bailiffDialogUrlAudio: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SECOND:
      return {
        ...state,
        bailiffDialogSecond: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_PLAY:
      return {
        ...state,
        bailiffDialogPlay: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_SLOT:
      return {
        ...state,
        bailiffDialogSlot: payload,
      };

    case TYPES.SET_BAILIFF_DIALOG_KICK:
      return {
        ...state,
        bailiffDialogKick: payload,
      };
    //
    case TYPES.SET_BAILIFF_DIALOG_OPTION_SPEAKER:
      return {
        ...state,
        bailiffDialogOptionSpeaker: payload,
      };
    default:
      return state;
  }
};

export default bailiffDialogReducer;
